(function () {
  'use strict';

  document.querySelectorAll('.kf-lp [data-kf-track]').forEach(function (track) {
    var dots = track.parentElement.querySelector('[data-kf-dots]');
    var items = Array.prototype.slice.call(track.children);
    var stops = [];
    if (!dots || !items.length) return;
    function build() {
      dots.innerHTML = '';
      stops = [];
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) { dots.hidden = true; return; }
      dots.hidden = false;
      items.forEach(function (item) {
        var x = Math.min(item.offsetLeft - items[0].offsetLeft, max);
        if (!stops.length || x - stops[stops.length - 1] > 4) stops.push(x);
      });
      stops.forEach(function (x, i) {
        var button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'Zu Position ' + (i + 1));
        button.addEventListener('click', function () { track.scrollTo({ left: x, behavior: 'smooth' }); });
        dots.appendChild(button);
      });
      mark();
    }
    function mark() {
      var x = track.scrollLeft, active = 0, distance = Infinity;
      stops.forEach(function (stop, i) {
        var next = Math.abs(stop - x);
        if (next < distance) { distance = next; active = i; }
      });
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    var timer;
    window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(build, 150); });
    build();
  });

  var sticky = document.getElementById('kf-sticky');
  var heroButton = document.querySelector('[data-kf-hero-cta]');
  var featuredSection = document.querySelector('.section-featured-product');
  if (featuredSection) featuredSection.setAttribute('data-kf-buybox', '');
  var featuredProduct = document.querySelector('[data-kf-buybox]');
  document.querySelectorAll('a[href="#kaufen"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (!featuredSection) return;
      event.preventDefault();
      var header = document.querySelector('sticky-header, .section-header, header');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
      window.scrollTo({
        top: window.scrollY + featuredSection.getBoundingClientRect().top - offset,
        behavior: 'smooth'
      });
      window.history.replaceState(null, '', '#kaufen');
    });
  });
  if (!sticky || !heroButton || !featuredProduct || !('IntersectionObserver' in window)) return;

  var heroVisible = true, productVisible = false;
  function updateSticky() {
    var show = !heroVisible && !productVisible;
    sticky.classList.toggle('is-show', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    var link = sticky.querySelector('a');
    if (link) link.tabIndex = show ? 0 : -1;
  }
  new IntersectionObserver(function (entries) {
    heroVisible = entries[0].isIntersecting;
    updateSticky();
  }).observe(heroButton);
  new IntersectionObserver(function (entries) {
    productVisible = entries[0].isIntersecting;
    updateSticky();
  }, { threshold: 0.1 }).observe(featuredProduct);
}());